import {
  createQueryKeyStore,
  inferQueryKeyStore,
} from "@lukemorales/query-key-factory"
import { edgeConfigClient } from "./client"

export const EdgeConfigQueries = createQueryKeyStore({
  maintenance: {
    config: () => ({
      queryKey: ["maintenanceConfig"],
      queryFn: () => edgeConfigClient.get(""),
    }),
  },
})

export type EdgeConfigQueryKeys = inferQueryKeyStore<typeof EdgeConfigQueries>
